<template>
  <div>
    <Header
      ref="header"
      v-if="tableName"
      :title="$route.meta.title"
      :table-name="tableName"
    >
      <MultipleItemsActions
        v-for="action in multipleActionButtons"
        :key="action.subject"
        :action="action"
        :table-name="tableName"
      />
    </Header>
    <Table
      ref="table"
      :key="tableName"
      :table-name="tableName"
      @openDetails="openTableDetails"
      @contextMenu="openContextMenu"
    >
      <template #tableTop>
        <FiltersBar
          ref="tableTop"
          :table-name="tableName"
          search-bar
          :search-bar-props="{class: 'mr-4'}"
          show-filters-button
          table-filters
        />
      </template>
      <template #stats>
        <TableStatisticsBar
          ref="statistics"
          :table-name="tableName"
        />
      </template>
    </Table>
    <TableConfirmationBar
      v-if="selectedItems.length"
      :confirm-actions="confirmationBarActions"
      :table-name="tableName"
      ref="confirmation"
    />
  </div>
</template>

<script>
import Header from '../../../components/Layout/Header'
import Table from '../../../components/Table/Table'
import FiltersBar from '../../../components/Filters/FiltersBar'
import TableStatisticsBar from '../../../components/Table/TableStatisticsBar'
import defaultTableEventsMixin from '../../../mixins/defaultTableEventsMixin'
import { mapState, mapGetters, mapActions } from 'vuex'
import actions from '../../../const/actions'
import { exportShortkeys } from '../../../const/shortKeys'
import MultipleItemsActions from '../../../components/Elements/MultipleItemsActions'
import TableConfirmationBar from '../../../components/Table/TableConfirmationBar'

export default {
  components: {
    Header,
    Table,
    FiltersBar,
    TableStatisticsBar,
    MultipleItemsActions,
    TableConfirmationBar,
  },
  mixins: [defaultTableEventsMixin],
  data: () => ({
    tableName: 'containers',
  }),
  computed: {
    ...mapState({
      departmentId: state => state.core.department.id,
      selectedItems: state => state.containers.selectedItems,
    }),
    ...mapGetters({
      getFilterValue: 'tables/getFilterValue'
    }),
    containerTypeFilter () {
      return this.getFilterValue(this.tableName, 'containerTypeIds')
    },
    multipleActionButtons() {
      return [
        { label: 'Eksportuj do csv', subject: 'export', shortkey: exportShortkeys, confirmActions: [actions.exportContainersToCsv] },
      ]
    },
    multiselectSubject() {
      return this.$store.state[this.tableName].multiselectSubject
    },
    confirmationBarActions () {
      return this.multipleActionButtons.find(action => action.subject === this.multiselectSubject)?.confirmActions || []
    },
  },
  watch: {
    containerTypeFilter () {
      this.getCounters()
    }
  },
  beforeRouteEnter (to, from, next) {
    // Containers and ContainerTypes views require global containerTypes
    if (from.name !== 'containerTypes') { next(vm => vm.getContainerTypes()) } else next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'containerTypes') this.getContainerTypes({ params: { departmentId: this.departmentId } })
    next()
  },
  methods: {
    ...mapActions({
      getContainerTypes: 'containerTypes/getItems',
      getCounters: 'containers/getCounters',
    }),
  }
}
</script>
